// See: https://i18n.nuxtjs.org/guide/seo
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { defaultLocale } from '@pkg/config/languages';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
interface Translation {
  title: string;
  slug: string;
  language: LOCALE_CODE
}
interface LinkData {
  id: string;
  rel: string;
  href: string;
  hreflang: string;
}

const getSlugParent = (docType: DOCUMENT) => {
  switch (docType) {
    case DOCUMENT.ABOUT_FOOD_WASTE_BLOG:
      return '/blog/';
    case DOCUMENT.PRESS_RELEASES:
      return '/press/';
    default:
      return '';
  }
};

/**
 * This composable is used to return the localised slugs of a page to accurately set the hreflinks in the <head> and should only be used in pages templates when trying to add localised hreflinks
 *
 * @param route - data from useRoute passed in from the page template.
 */
export function useHrefLinks(route: any) {
  const { public: { domain } } = useRuntimeConfig();
  /**
   *
   * @param linkData - Data provided by nuxt/i18n's composable useLocaleHead, see https://i18n.nuxtjs.org/docs/guide/seo.
   * @param pageTranslations - The translations object from the page data, including the locale and its slug
  */
  const getLocalizedHref = (linkData: LinkData, pageTranslations: Array<Translation | null>, docType: DOCUMENT) => {
    const routeLocaleCode = computed(() => route.path.substring(1).replace(/\/+$/, ''));
    const isLocaleCode = computed(() => Object.values(LOCALE_CODE).includes(routeLocaleCode.value));
    const isHomeRoute = computed(() => routeLocaleCode.value === '' || isLocaleCode.value);

    let hrefLink = '';
    if (linkData.hreflang !== defaultLocale) {
      hrefLink = linkData.hreflang ? `/${linkData.hreflang}` : `/${routeLocaleCode.value}`;
    }

    if (isHomeRoute.value) { return `${domain}${hrefLink}`; }

    const translation = pageTranslations && pageTranslations.find(
      translation => translation?.language === linkData.hreflang,
    );

    const translationSlug = isHomeRoute.value ? '' : `${getSlugParent(docType)}${translation?.slug}`;

    return translation ? `${domain}${hrefLink}${translationSlug}` : null;
  };

  return {
    getLocalizedHref,
  };
}
